import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Select, TimePicker } from "antd";
import dayjs from "dayjs";
import { getCurrentFormattedDate } from "core/Operations/currentDateTime";
import { useFormContext } from "react-hook-form";
import { toast } from "core/Operations/toast";

const timeValue = ["inTime", "outTime", "waitingTime", "wtrot"];

const bulkChangeOptionsAlternate = [
  {
    label: "In Time",
    value: "inTime",
  },
  {
    label: "Out Time",
    value: "outTime",
  },
  {
    label: "Shift",
    value: "shift",
  },
];

const bulkChangeOptions = [
  {
    label: "In Time",
    value: "inTime",
  },
  {
    label: "Out Time",
    value: "outTime",
  },
  {
    label: "Waiting Time",
    value: "waitingTime",
  },
  {
    label: "WTR OT",
    value: "wtrot",
  },
  {
    label: "Shift",
    value: "shift",
  },
  {
    label: "Project",
    value: "project",
  },
];
const BulkChange = ({
  attendance,
  selectedRow,
  shifts,
  shiftOptions,
  projectsOptions,
  onSubmit,
  resetData,
  setResetData,
}) => {
  const { watch } = useFormContext();
  const [bulkChangeType, setBulkChangeType] = useState("");
  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [selectedTime, setSelectedTime] = useState("00:00:00");
  const [selectedProject, setSelectedProject] = useState(0);
  const [selectedProjectName, setSelectedProjectName] = useState("");
  const [selectedShift, setSelectedShift] = useState(0);
  const [selectedShiftName, setSelectedShiftName] = useState("");
  const [hasOutTime, setHasOutTime] = useState(false);

  const getShiftTime = (type) => {
    const selectedShiftData = shifts.find(
      (s) => s.shiftPolicyID === Number(selectedShift),
    );
    if (type === "inTime" && selectedShiftData?.shiftStartTime) {
      return selectedShiftData.shiftStartTime;
    }
    if (type === "outTime" && selectedShiftData?.shiftEndTime) {
      return selectedShiftData.shiftEndTime;
    }

    return "00:00:00";
  };
  const updateHandler = () => {
    const selectedEmployees = attendance.filter((a) =>
      selectedRow.includes(a.id),
    );

    if (["project", "waitingTime", "wtrot", "outTime", "inTime", "shift"].includes(bulkChangeType)) {
      const haveAlternateDayOff = selectedEmployees?.some(
        (s) => s.isAlternateDayOff,
      );
      if (haveAlternateDayOff) {
        toast.warning(
          `Some selected rows are marked as Alternate Day Off. Please review your selection.`,
        );

        return;
      }
    }

    if (bulkChangeType === "outTime") {
      const haveEmployeesMissingIntime = selectedEmployees?.some(
        (s) => s.inTime === "00:00:00" || s.inTime === "00:00",
      );
      if (haveEmployeesMissingIntime) {
        toast.warning(
          `Some selected rows intime are missing. Please review your selection.`,
        );
        return;
      }
    }

    const newValue = ["inTime", "outTime", "waitingTime", "wtrot"].includes(
      bulkChangeType,
    )
      ? {
          [bulkChangeType]: selectedTime,
        }
      : bulkChangeType === "shift"
        ? {
            shiftId: selectedShift,
            hasOutTime: true,
            // inTime: getShiftTime("inTime"),
            // outTime: getShiftTime("outTime"),
          }
        : bulkChangeType === "project"
          ? {
              projectCode: selectedProject,
              projectName: selectedProjectName,
            }
          : {};

    const updatedData = selectedEmployees
      ?.filter((s) => s.isFullPaidLeave === false)
      .map((s) => ({
        ...s,
        slno: s.slno || 0,
        //selectedEmployees?.map((s) => ({
        slNo: s.slno || 0,
        companyCode: s.companyCode,
        locationCode: s.locationCode,
        employeeCode: s.employeeCode,
        attendanceValue: 1,
        attendanceDate: s.attendanceDate,
        inTime:
          s.isPaidLeave === 1
            ? "00:00:00"
            : bulkChangeType === "shift"
              ? s.inTime === "00:00:00" || s.inTime === "00:00"
                ? getShiftTime("inTime")
                : s.inTime
              : s.inTime,
        outTime:
          s.isPaidLeave === 1
            ? "00:00:00"
            : bulkChangeType === "shift"
              ? s.outTime === "00:00:00" || s.outTime === "00:00"
                ? getShiftTime("outTime")
                : s.outTime
              : hasOutTime || s.hasOutTime
                ? s.outTime
                : null,
        hasOutTime:
          s.isPaidLeave === 1
            ? false
            : bulkChangeType === "shift"
              ? getShiftTime("outTime") !== "00:00:00" &&
                getShiftTime("outTime") !== "00:00"
              : s.outTime !== "00:00:00" && s.outTime !== "00:00",
        // outTime: s.outTime,
        createUser: s.createUser || watch("userName"),
        createDate: s.createDate || getCurrentFormattedDate(),
        modifyUser: watch("userName"),
        modifyDate: getCurrentFormattedDate(),
        scheduleId: s.scheduleId || 0,
        projectCode: s.projectCode || "",
        shiftId: s.shiftId || s?.defaultShift.toString() || "",
        remarks:
          s.remarks === "Rest Day" || s.remarks === "Weekly Off"
            ? ""
            : s.remarks || "",
        mode: s.mode || "MM",
        waitingTime: s.waitingTime || "00:00:00",
        wtrot: s.wtrot || "00:00:00",
        isApproved: s.isApproved || false,
        oT1: s.oT1 || 0,
        oT2: s.oT2 || 0,
        extraCharge: s.extraCharge || 0,
        wtnhEdit: s.wtnhEdit || false,
        supplierCompany: s.supplierCompany || "",
        service: s.service || "",
        isReviewed: s.isReviewed || false,
        reviewDate: s.reviewDate || s.attendanceDate,
        reviewBy: s.reviewBy || "",
        approvedDate: s.approvedDate || s.attendanceDate,
        approvedBy: s.approvedBy || "",
        normalWorkingHours: s?.normalWorkingHours || 0,
        normalHours: s?.normalWorkingHours || 0,
        isAlternateDayOff: false,
        ...newValue,
      }));

    if (updatedData.length > 0) {
      onSubmit(updatedData);
    } else {
      toast.warning("Please select a valid attendance row");
    }
  };

  const BulkChangeOnClearHandler = () => {
    setShowUpdateButton(false);
    setBulkChangeType("");
    setSelectedShift(0);
    setSelectedProject(0);
    setSelectedTime("00:00:00");
  };

  useEffect(() => {
    if (resetData) {
      setSelectedShift(0);
      setSelectedProject(0);
      setSelectedTime("00:00:00");
      setResetData(false);
    }
  }, [resetData]);
  return (
    <>
      {selectedRow.length > 0 && (
        <div className="row mb-3">
          <div className="col-md-3">
            <label className="form-label">Bulk Change</label>
            <Select
              placeholder="Select Option"
              className="select "
              options={bulkChangeOptions}
              onChange={(selectedOptions) => {
                setBulkChangeType(selectedOptions);
                setShowUpdateButton(true);
              }}
              onClear={() => BulkChangeOnClearHandler}
              // onClear={() => setBulkChangeType("")}
              showSearch
              style={{ width: "100%" }}
              allowClear
              size="large"
            />
          </div>

          <div className="col-md-3">
            {bulkChangeType === "inTime" ||
            bulkChangeType === "outTime" ||
            bulkChangeType === "waitingTime" ||
            bulkChangeType === "wtrot" ? (
              <>
                <label className="form-label">Time</label>
                <TimePicker
                  value={selectedTime ? dayjs(selectedTime, "HH:mm") : null}
                  placeholder=""
                  className={`form-control form-control-time-width`}
                  onChange={(time, timeString) => {
                    if (bulkChangeType === "outTime") {
                      setHasOutTime(true);
                    }

                    const fullTimeString = time
                      ? time.format("HH:mm:ss")
                      : null;
                    setSelectedTime(fullTimeString);
                  }}
                  format="HH:mm"
                  variant="borderless "
                  allowClear={true}
                  style={{ width: "110px" }}
                  inputReadOnly={true}
                />
              </>
            ) : bulkChangeType === "shift" ? (
              <div className="form-group">
                <label className="form-label"> Shift</label>
                <Select
                  name="shift"
                  className="select"
                  options={shiftOptions}
                  labelInValue
                  onSelect={(e) => {
                    console.log(e);
                    setSelectedShift(e.value);
                    setSelectedShiftName(e.label);
                    setHasOutTime(true);
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            ) : bulkChangeType === "project" ? (
              <div className="form-group">
                <label className="form-label"> Project</label>

                <Select
                  name="project"
                  className="select"
                  // value={{
                  //   label: watch(`attendance[${record.id}].shiftName`) || "",
                  //   // label: watch(`attendance[${record.id}].shiftCode`) || "",
                  // }}
                  options={projectsOptions}
                  labelInValue
                  onSelect={(e) => {
                    setSelectedProject(e.value);
                    setSelectedProjectName(e.label);
                  }}
                  style={{ width: "100%" }}
                />
              </div>
            ) : (
              ""
            )}
            <br />
            {bulkChangeType && bulkChangeType !== "" && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={updateHandler}
                disabled={
                  (bulkChangeType === "project" && selectedProject === 0) ||
                  (bulkChangeType === "shift" && selectedShift === 0)
                  // bulkChangeType === "inTime" ||
                  // bulkChangeType === "outTime" ||
                  // bulkChangeType === "waitingTime" ||
                  // (bulkChangeType === "wtrot" && selectedTime === 0)
                }
              >
                Update
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

BulkChange.propTypes = {
  selectedRow: PropTypes.array.isRequired,
  attendance: PropTypes.array.isRequired,
  shifts: PropTypes.array.isRequired,
  shiftOptions: PropTypes.array.isRequired,
  projectsOptions: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
  resetData: PropTypes.bool.isRequired,
  setResetData: PropTypes.func.isRequired,
};

export default BulkChange;
